// extracted by mini-css-extract-plugin
export default {"wrapper":"UserActInfo_wrapper__Pxs-6"};